import React from 'react';
import styled, { keyframes, css } from 'styled-components';

const SkeletonCard = () => {
    return (
        <CardWrapper>
            <MainContent>
                <TextContent>
                    <TitlePlaceholder />
                    <ValuePlaceholder />
                </TextContent>
                <IconPlaceholder />
            </MainContent>
            <BottomAccentPlaceholder />
        </CardWrapper>
    );
};

export default SkeletonCard;

// Animations
const shimmer = keyframes`
    0% {
        background-position: -468px 0;
    }
    100% {
        background-position: 468px 0;
    }
`;

const skeletonAnimation = css`
    background: #f6f7f8;
    background-image: linear-gradient(
        to right,
        #f6f7f8 0%,
        #edeef1 20%,
        #f6f7f8 40%,
        #f6f7f8 100%
    );
    background-repeat: no-repeat;
    background-size: 800px 104px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: ${shimmer};
    animation-timing-function: linear;
`;

// Styled Components matches StatCard.js structure
const CardWrapper = styled.div`
    background: #ffffff;
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    min-height: 140px;
`;

const MainContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 0.75rem;
`;

const TextContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    flex: 1;
`;

const TitlePlaceholder = styled.div`
    height: 14px;
    width: 60%;
    border-radius: 4px;
    ${skeletonAnimation}
`;

const ValuePlaceholder = styled.div`
    height: 26px;
    width: 80%;
    border-radius: 4px;
    ${skeletonAnimation}
`;

const IconPlaceholder = styled.div`
    width: 48px;
    height: 48px;
    border-radius: 12px;
    margin-left: 1rem;
    flex-shrink: 0;
    ${skeletonAnimation}
`;

const BottomAccentPlaceholder = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 4px;
    ${skeletonAnimation}
    opacity: 0.6;
`;
